// PAGES
import Home from "./pages/Home";

// COMPONENTS
import NavigationBar from "./components/NavigationBar";

function App() {
  return (
    <>
      <NavigationBar />
      <Home />
    </>
  );
}

export default App;
